import { Add, GridView } from "@mui/icons-material";
import { FormControlLabel, Radio } from "@mui/material";
import React from "react";
import {
    Link,
    NavLink,
    Outlet,
    useLocation,
    useParams,
} from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";

function EverSignDocuments() {
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const name = path.replace("-", " ");
    const { is_completed } = useParams();
    console.log(is_completed);
    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{name}</span>
                </div>
                <div>
                    <NavLink
                        exact
                        to="/dashboard/eversign-documents"
                        style={{ margin: "0px 5px" }}
                        className={!is_completed ? "route-active" : "route-not-active"}
                    >
                        All Documents
                    </NavLink>
                    <NavLink
                        exact
                        to="/dashboard/eversign-documents/signed=1"
                        style={{ margin: "0px 5px" }}
                        className={is_completed == 1 ? "route-active" : "route-not-active"}
                    >
                        Signed
                    </NavLink>
                    <NavLink
                        exact
                        to="/dashboard/eversign-documents/signed=2"
                        style={{ margin: "0px 5px" }}
                        className={is_completed == 2 ? "route-active" : "route-not-active"}
                    >
                        Unsigned
                    </NavLink>
                </div>{" "}
            </HeaderTable>
            <Outlet />
        </>
    );
}

export default EverSignDocuments;
